import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import styles from "./menu.module.css";
import { UserContext } from "../../context";
import { Spin, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { divide } from "lodash";
import { TContext } from "../../types/config";

type TProps = {
  isOpen?: any;
  sideBarStatus?: boolean;
};

export default function SidebarComponent(props: TProps) {
  const context: TContext = useContext(UserContext);
  const menuData = context.menuHierarchy;
  const navigate = useNavigate(); // Replaces useRouter from Next.js

  // Make sure to import Tooltip from Ant Design

  const MenuItem = ({ item }: any) => {
    const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const toggleSubMenu = () => {
      setIsSubMenuVisible(!isSubMenuVisible);
      if (item.parentId === 0 || (item.children && item.children.length > 0)) {
        setIsActive(!isActive);
      }
    };

    const hasChildren = (item: any) => {
      return item.children && item.children.length > 0;
    };

    const isChildActiveRecursive = (children: any) => {
      return (
        children &&
        children.some((child: any) => {
          if (child.children) {
            return isChildActiveRecursive(child.children);
          }
          return window.location.pathname === child.entityUrl;
        })
      );
    };

    useEffect(() => {
      const isChildActive = isChildActiveRecursive(item.children);
      setIsSubMenuVisible(isChildActive);
      setIsActive(isChildActive || window.location.pathname === item.entityUrl);
    }, [item.children, item.entityUrl, item.parentId]);

    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent click propagation
      if (!hasChildren(item)) {
        navigate(item.entityUrl);
      }
    };

    const IconRenderer = ({ iconName }: { iconName: string | undefined }) => {
      const FaIcon: any = Icons[iconName as keyof typeof Icons];
      return FaIcon ? (
        <FontAwesomeIcon icon={FaIcon} size="sm" />
      ) : (
        <span className={styles.spanOfInconStyle}>-</span>
      );
    };

    return (
      <div
        className={classNames(styles.user_menu, {
          [styles.contentExpanded]: props?.sideBarStatus,
        })}
      >
        <Tooltip
          title={!props?.sideBarStatus && item.dispName}
          placement="right"
        >
          <div
            className={classNames(styles.item, { [styles.active]: isActive })}
            onClick={hasChildren(item) ? toggleSubMenu : handleClick}
          >
            <div className={styles.iconStyle}>
              <span className={styles.spanOfInconStyle}>
                <IconRenderer iconName={item?.iconName || ""} />
              </span>
              <span className={`${styles.menu_name} ${styles.spanDispName}`}>
                {props?.sideBarStatus ? item.dispName : ""}
              </span>
            </div>

            {hasChildren(item) && props.sideBarStatus && (
              <div>
                {isSubMenuVisible ? (
                  <FontAwesomeIcon icon={faCaretUp} />
                ) : (
                  <FontAwesomeIcon icon={faCaretDown} />
                )}
              </div>
            )}
          </div>
          {isSubMenuVisible && hasChildren(item) && (
            <div className={styles.sub_menu}>
              {item.children.map((subItem: any, index: any) => (
                <MenuItem key={index} item={subItem} />
              ))}
            </div>
          )}
        </Tooltip>
      </div>
    );
  };

  return (
    <div>
      <div className={styles.user_sidebar}>
        <div className={styles.user_detail}>
          <div
            className={
              props?.sideBarStatus
                ? styles.user_pic_expanded
                : styles.user_pic_compact
            }
          ></div>
        </div>
        {menuData && menuData?.length > 0 ? (
          <div className={styles.menuSection}>
            {menuData &&
              menuData?.map((item: any, index: number) => (
                <MenuItem key={index} item={item} />
              ))}
          </div>
        ) : (
          <div className={styles.spinContainer}>
            <Spin></Spin>
          </div>
        )}
      </div>
    </div>
  );
}
